import { ReactElement, ReactNode } from 'react';

import { Typography, TypographyProps } from '@mui/material';

import NoDataCell from '../NoDataCell';

export type FallbackCellProps<Value = unknown> = Omit<TypographyProps, 'children'> & {
  value?: Value | null;
  fallback?: ReactElement | string | number;
  isEmpty?: (val: Value | null | undefined) => val is null | undefined;
  disableTypography?: boolean;
  children?: (val: Value) => ReactNode;
};

export const defaultIsCellValueEmpty = (val: unknown): val is null | undefined => val === undefined || val === null;
export const defaultRenderCellValue = (val: unknown) => val as ReactNode;

export default function FallbackCell<Value = unknown>({
  value,
  fallback = <NoDataCell />,
  isEmpty = defaultIsCellValueEmpty,
  children: renderValue = defaultRenderCellValue,
  disableTypography = false,
  ...typographyProps
}: FallbackCellProps<Value>): ReactElement {
  if (isEmpty(value)) {
    return fallback as ReactElement;
  }

  const displayValue = renderValue(value);

  return disableTypography ? (
    <>{displayValue}</>
  ) : (
    <Typography component="span" {...typographyProps}>
      {displayValue}
    </Typography>
  );
}
